import React from "react";
import { View } from "react-native";
import { graphql, useFragment } from "react-relay";
import { AHImageStackComponent_Images$key } from "./__generated__/AHImageStackComponent_Images.graphql";
import { Image, useLayoutContext } from "arkh";

export const AHImageStackNew = (props: {
  images: AHImageStackComponent_Images$key;
  size?: number;
}) => {
  const images = useFragment(
    graphql`
      fragment AHImageStackComponent_Images on Image @relay(plural: true) {
        id
        ...Image_image
      }
    `,
    props.images
  );

  const size = props.size ?? 30;
  const layout = useLayoutContext();

  return (
    <View
      style={{
        marginTop: images.length > 1 ? 2 : 0,
        marginBottom: images.length > 1 ? 0 : 2,
        width: size,
        height: size,
      }}
    >
      {images.length > 1 && images[1] ? (
        <View
          style={{
            height: size,
            width: size,
            borderRadius: layout.radius.medium,
            bottom: 6,
            position: "absolute",
            transform: [{ scale: 0.8 }],
            opacity: 0.4,
            overflow: "hidden",
          }}
        >
          <Image
            type="remote"
            id={images[1].id}
            image={images[1]}
            style={{ flex: 1 }}
          />
        </View>
      ) : null}
      {images.length > 0 && images[0] ? (
        <Image
          style={{
            height: size,
            width: size,
            borderRadius: layout.radius.medium,
          }}
          recyclingKey={images[0].id}
          type="remote"
          id={images[0].id}
          image={images[0]}
        />
      ) : null}
    </View>
  );
};
